// Deprecated from default presets: publicly hosted SIMID test tags are unreliable
// in local environments and often fail for reasons outside this tester.
// Keep this export for registry compatibility.
export const simidTags = [];
